var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.error_message)?_c('b-alert',{attrs:{"variant":"danger","show":""}},[_vm._v(" "+_vm._s(_vm.error_message)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }